import { render, staticRenderFns } from "./resourceSelectionNew.vue?vue&type=template&id=3d125a19&scoped=true"
import script from "./resourceSelectionNew.vue?vue&type=script&lang=js"
export * from "./resourceSelectionNew.vue?vue&type=script&lang=js"
import style0 from "./resourceSelectionNew.vue?vue&type=style&index=0&id=3d125a19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d125a19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d125a19')) {
      api.createRecord('3d125a19', component.options)
    } else {
      api.reload('3d125a19', component.options)
    }
    module.hot.accept("./resourceSelectionNew.vue?vue&type=template&id=3d125a19&scoped=true", function () {
      api.rerender('3d125a19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/resourceSelectionNew.vue"
export default component.exports